// @flow

import React, { useMemo } from "react";
import classNames from "classnames";

import { SwitchButton, View } from "@components";
import type { WidgetProps } from "@rjsf/utils";

type Props = {
  ...WidgetProps,
  options: Object,
};

export function SwitchButtonWidget(props: Props) {
  const { value } = props;

  const isValueBoolean = useMemo(() => {
    return typeof value === "boolean";
  }, [value]);

  const fieldValue = useMemo(() => {
    if (isValueBoolean) {
      return value;
    }

    return value === "ACTIVE";
  }, [value, isValueBoolean]);

  const handleChange = (val: boolean) => {
    let newValue = val;
    if (!isValueBoolean) {
      newValue = val ? "ACTIVE" : "INACTIVE";
    }
    props.onChange && props.onChange(newValue);
  };

  return (
    <View>
      <SwitchButton
        id={props.id}
        name={props.name}
        active={fieldValue}
        onChange={handleChange}
        disabled={props.disabled}
        readonly={props.readonly}
        className={classNames("", props.className)}
        buttonType="button"
      />
    </View>
  );
}

export default SwitchButtonWidget;
